import { render, staticRenderFns } from "./SaucesDetails.vue?vue&type=template&id=0707aedf&scoped=true&"
import script from "./SaucesDetails.vue?vue&type=script&lang=js&"
export * from "./SaucesDetails.vue?vue&type=script&lang=js&"
import style0 from "./SaucesDetails.vue?vue&type=style&index=0&id=0707aedf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0707aedf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
